<template>
  <div id="main-header">
    <div id="main-header__content">
      <div class="max-w-5xl mx-auto">
        <NuxtLink to="/">
          <img src="~/assets/images/logo.png" alt="logo" class="w-24 pb-3" />
        </NuxtLink>
        <slot name="content">
          <ui-navbar :type="navbarType" />
        </slot>
      </div>
    </div>
    <div id="main-header__actions" class="max-w-5xl mx-auto text-center pt-5">
      <slot name="actions" v-if="showActions">
        <h2 class="text-2xl font-bold text-white my-3">Regali solidali per categoria</h2>
        <ui-actions :active="activeFilter" :animate="filterAnimationSpacer" @select="toggleFilter"></ui-actions>
      </slot>
    </div>
  </div>
</template>

<style lang="scss">
#main-header {
  padding: 1rem 1rem 2rem;

  &__actions {
    position: relative;
    z-index: 20;
  }

  //max-width: 640px;
  //text-align: center;
  z-index: 9980;
  width: 100%;
  //position: fixed;
  top: 0;
}
</style>
<script setup lang="ts">
const props = defineProps({
  navbarType:{
    type: String,
    default: 'dark'
  },
  showActions:{
    type: Boolean,
    default: false
  }
});

const filterAnimationSpacer = ref(true)
const activeFilter = ref({
  key: null,
  slug: null
});

const toggleFilter = (action) => {
  if (activeFilter.value && activeFilter.value.key === action.key) {
    navigateTo(`/`)
  } else {
    if (action.slug) {
      navigateTo(`/categoria/${action.slug}`)
    } else {
      showUnderConstructionModal(action.label);
    }
    //setFilter(action);
  }
}
</script>